import { axios } from "../config";

function getAllAnnouncementData(data) {
  return axios.get("api/v1/announcement/all", { params: data });
}

function createAnnouncement(data) {
  return axios.post("api/v1/announcement", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

function updateAnnouncement(id, data) {
  return axios.put(`api/v1/announcement/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}


function deleteAnnouncement(id) {
  return axios.delete(`api/v1/announcement/${id}`);
}

function getAllLevels() {
  return axios.get("api/v1/levels");
}


export { getAllAnnouncementData, createAnnouncement, updateAnnouncement, deleteAnnouncement, getAllLevels };
